import React from 'react';
import * as AlertDialog from '@radix-ui/react-alert-dialog';

interface SuccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onContinue: () => void;
}

export const SuccessDialog: React.FC<SuccessDialogProps> = ({
  open,
  onOpenChange,
  onContinue,
}) => {
  return (
    <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="dialog-overlay fixed inset-0 bg-black/80 z-[200]" />
        <AlertDialog.Content className="dialog-content fixed left-[50%] top-[50%] z-[201] max-h-[85vh] w-[90vw] max-w-[500px] translate-x-[-50%] translate-y-[-50%] rounded-lg bg-secondary border border-border p-6 shadow-lg">
          <div className="text-center">
            {/* Logo */}
            <div className="mb-1">
              <img
                src="/youAreInLogo.png"
                alt="You're In!"
                className="w-48 h-48 mx-auto object-cover"
              />
            </div>
            
            {/* Title */}
            <AlertDialog.Title className="text-2xl font-bold text-text-primary mb-4">
              Welcome to Trigger!
            </AlertDialog.Title>
            
            {/* Description */}
            <AlertDialog.Description className="text-text-secondary mb-8 text-base leading-relaxed">
              You can now close this app and use the bot directly on Telegram or click Continue to start referring friends and earn $TRIGGER.
            </AlertDialog.Description>
            
            {/* Continue Button */}
            <AlertDialog.Action asChild>
              <button 
                className="w-full bg-accent text-text-primary py-3 rounded-lg hover:bg-accent-hover transition-colors font-medium"
                onClick={onContinue}
              >
                Continue
              </button>
            </AlertDialog.Action>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
};
